import { numberFormatter } from '../../utils/commonUtils';
import { ValidationCard } from '..';

const columns = [
  {
    title: 'Date and Time',
    dataIndex: 'redemeed_at',
    key: 'redemeed_at',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item, record) => {
      if (item) {
        const date = item.format('DD MMMM YYYY');
        const time = item.format('HH:MM:ss');

        return (
          <ValidationCard
            title={date}
            description={time}
            isValid={record?.is_valid}
          />
        );
      }
      return '-';
    },
  },
  {
    title: 'Location',
    dataIndex: 'store_name',
    key: 'store_name',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item) => {
      if (item) {
        return item;
      }
      return '-';
    },
  },
  {
    title: 'Qty',
    dataIndex: 'qty',
    key: 'qty',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item) => {
      if (item) {
        return numberFormatter(item);
      }
      return '-';
    },
  },
  {
    title: 'Total Sales',
    dataIndex: 'total_sales',
    key: 'total_sales',
    sorter: (a, b) => {
      return a.name.toString().localeCompare(b.name.toString());
    },
    render: (item, record) => {
      const { is_valid: isValid } = record;
      if (item) {
        return numberFormatter(item);
      }
      if (!isValid) {
        return <div className="red1 font-paragraph">Invalid Data</div>;
      }
      return '-';
    },
  },
];

export default columns;
